module.exports = __webpack_public_path__ + "4437f8c4650c1107886704097166fcd7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-4.png
// module id = 2060
// module chunks = 0